if (!customElements.get('tree-dealer-mobile-app')) {
  customElements.define('tree-dealer-mobile-app', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.header = this.closest('tree-navigation');
      this.drawer = this.header?.querySelector('[data-nav-drawer]');
      this.sheet = this.querySelector('dialog');
      this.shop = this.querySelector('[data-dealer-app-shop]');
      this.home = this.querySelector('.tc-dealer-app-dock>a');
      this.homePage = this.home?.hasAttribute('aria-current');
      this.shopPage = this.shop?.hasAttribute('aria-current');
      this.mobile = matchMedia('(max-width:760px)');
      if (!this.header || !this.drawer || !this.sheet || !this.shop) return;
      this.accountButtons = [...this.header.querySelectorAll('[data-dealer-app-account]')];
      this.shop.addEventListener('click', () => {
        const opening = !this.drawer.open;
        this.header.closeAll?.(false);
        this.drawer.open = opening;
        if (opening) {
          const branch = this.drawer.querySelector('.tc-finish-branch');
          if (branch) branch.open = true;
          this.header.measureVisible?.();
        }
        this.reflectMenu();
      }, options);
      this.drawer.addEventListener('toggle', () => this.reflectMenu(), options);
      this.accountButtons.forEach(button => button.addEventListener('click', () => {
        if (this.sheet.open) return;
        this.returnFocus = button;
        this.header.closeAll?.(false);
        this.reflectMenu();
        this.sheet.showModal();
        document.body.classList.add('tc-dealer-app-sheet-open');
        this.accountButtons.forEach(item => item.setAttribute('aria-expanded','true'));
      }, options));
      this.querySelector('[data-dealer-app-close]').addEventListener('click', () => this.sheet.close(), options);
      this.sheet.addEventListener('click', event => {
        if (event.target !== this.sheet) return;
        const rect = this.sheet.getBoundingClientRect();
        if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) this.sheet.close();
      }, options);
      this.sheet.addEventListener('close', () => {
        document.body.classList.remove('tc-dealer-app-sheet-open');
        this.accountButtons.forEach(item => item.setAttribute('aria-expanded','false'));
        this.returnFocus?.focus({preventScroll:true});
      }, options);
      this.mobile.addEventListener('change', () => {
        if (!this.mobile.matches && this.sheet.open) this.sheet.close();
        this.reflectMenu();
      }, options);
      this.reflectMenu();
    }
    reflectMenu() {
      const open = this.mobile.matches && this.drawer.open;
      this.shop.setAttribute('aria-expanded',String(open));
      if (open || this.shopPage) this.shop.setAttribute('aria-current','page');
      else this.shop.removeAttribute('aria-current');
      if (this.homePage && !open) this.home.setAttribute('aria-current','page');
      else this.home?.removeAttribute('aria-current');
      document.body.classList.toggle('tc-dealer-app-menu-open',open);
    }
    disconnectedCallback() {
      if (this.sheet?.open) this.sheet.close();
      this.controller?.abort();
      this.controller = null;
      document.body.classList.remove('tc-dealer-app-sheet-open','tc-dealer-app-menu-open');
    }
  });
}
